"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const VenuePicker_1 = __importDefault(require("./Pages/VenuePicker"));
const ClientVenuePicker_1 = __importDefault(require("./Pages/ClientVenuePicker"));
const MainLayout_1 = __importDefault(require("./Pages/MainLayout"));
const KioskHeader_1 = __importDefault(require("./Header/KioskHeader"));
const DsStream_1 = __importDefault(require("./Pages/DsStream"));
const ExternalPage = styled_components_1.default.div `
  width: 100vw;
  height: 100vh;

  .kiosk-header {
    height: 8%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    #back-to-kiosk-btn {
      height: 100%;
      width: 8vh;
      background-color: white;
      border: none;

      svg {
        height: 50%;
        width: 50%;
      }
    }
  }
  iframe {
    width: 100%;
    height: 92%;
  }
`;
const App = () => {
    const [externalPageOpen, setExternalPageOpen] = (0, react_1.useState)(false);
    const [externalSrc, setExternalSrc] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const kioskEnabled = window.location.search.includes("kioskEnabled");
        const handleClick = (evt) => {
            const closestAnchorTagParent = evt.target.closest("a");
            const isExternalLink = closestAnchorTagParent && closestAnchorTagParent.target === "_blank";
            if (isExternalLink) {
                evt.preventDefault();
                setExternalPageOpen(true);
                setExternalSrc(closestAnchorTagParent.href);
            }
        };
        if (kioskEnabled) {
            window.addEventListener("click", handleClick);
        }
        return () => {
            if (kioskEnabled) {
                window.removeEventListener("click", handleClick);
            }
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !externalPageOpen && (react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/", render: () => {
                    window.location.href =
                        "https://www.hotel-mssngr.com/channel/digital-signage/";
                    return null;
                } }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/pickyourvenue", component: VenuePicker_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/configurator", component: ClientVenuePicker_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:brand/:slug/streams/:streamSlug", component: DsStream_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:brand/:slug/", component: MainLayout_1.default }))),
        externalPageOpen && (react_1.default.createElement(ExternalPage, null,
            react_1.default.createElement(KioskHeader_1.default, { setExternalPageOpen: setExternalPageOpen }),
            react_1.default.createElement("iframe", { title: "DS external content", src: externalSrc })))));
};
exports.default = App;
